import constants from 'Constants.js';

const url=constants.APP_URL + '/help/index2.php';

const PFDocumentationLinkRoot = {
    'L':url+'?id=fd_c_fp',
    'R':url+'?id=rd_c_rp',
    'page':url+'?id=fd_l_page',
    'behavior':url+'?id=fd_b_tb',
    'workflow':url+'?id=fd_w_properties',
    'control_text':url+'?id=fd_l_text',
    'control_small_text':url+'?id=fd_l_smalltext',
    'control_large_heading':url+'?id=fd_l_largeheading',
    'control_medium_heading':url+'?id=fd_l_mediumheading',
    'control_small_heading':url+'?id=fd_l_smallheading',
    'control_picture':url+'?id=fd_l_picture',
    'control_button':url+'?id=fd_l_button',
    'control_submit_button':url+'?id=fd_l_submitbutton',
    'control_page_button':url+'?id=fd_l_pagebutton',
    'control_group':url+'?id=fd_l_group',
    'control_checkbox_group':url+'?id=fd_l_checkboxgroup',
    'control_radio_button_group':url+'?id=fd_l_radiobuttongroup',
    'control_text_input':url+'?id=fd_l_textinput',
    'control_multiple_text_input':url+'?id=fd_l_multiline',
    'control_numeric_input':url+'?id=fd_l_numeric',
    'control_date_input':url+'?id=fd_l_date',
    'control_time_input':url+'?id=fd_l_time',
    'control_date_calendar': url + '?id=fd_l_calendar',
    'control_checkbox':url+'?id=fd_l_checkbox',
    'control_radio_button':url+'?id=fd_l_radiobutton',
    'control_drop_down':url+'?id=fd_l_dropdown',
    'control_list':url+'?id=fd_l_list',
    'control_bullet_text':url+'?id=fd_l_bullet',
    'control_vertical_separator':url+'?id=fd_l_vertical',
    'control_horizontal_separator':url+'?id=fd_l_horizontal',
    'control_sound':constants.APP_URL + '/documentation/help_guide/html/index.html',
    'control_movie':constants.APP_URL + '/documentation/help_guide/html/index.html',
    'control_link':url+'?id=fd_l_link',
    'control_progress_bar':url+'?id=fd_l_progress',
    'control_timer': url + '?id=fd_l_timer',
    'control_print_button':url+'?id=fd_l_printbutton',
    'control_captcha':url+'?id=fd_l_captcha',
    'control_mask_text_input':url+'?id=fd_l_masktext',
    'control_numeric_stepper':url+'?id=fd_l_numericstepper',
    'control_password_input':url+'?id=fd_l_password',
    'control_file_attachment':url+'?id=fd_l_fileattach',
    'control_image_input':url+'?id=fd_l_image',
    'control_websignature':url+'?id=fd_l_websignature',
    'control_vertical_slider':url+'?id=fd_l_vertical_sl',
    'control_horizontal_slider':url+'?id=fd_l_horizontal_sl',
    'control_ranking':url+'?id=fd_l_rank',
    'control_table':url+'?id=fd_l_table',
    'buttonColumn':url+'?id=fd_l_table_button',
    'checkboxColumn':url+'?id=fd_l_table_checkbox',
    'childFormColumn':url+'?id=fd_l_table_childform',
    'dateInputColumn':url+'?id=fd_l_table_date',
    'dropdownColumn':url+'?id=fd_l_table_dropdown',
    'fileAttachmentColumn':url+'?id=fd_l_table_fileattach',
    'numericInputColumn':url+'?id=fd_l_table_numeric',
    'radioButtonColumn':url+'?id=fd_l_table_radio',
    'textAreaColumn':url+'?id=fd_l_table_textarea',
    'timeInputColumn':url+'?id=fd_l_table_time',
    'textInputColumn':url+'?id=fd_l_table_textinput',
    'control_play_form_button':url+'?id=fd_l_showformbutton',
    'control_play_report_button':url+'?id=fd_l_showreportbutton',
    'control_bar_chart':url+'?id=rd_l_bar',
    'control_pie_chart':url+'?id=rd_l_pie',
    'control_line_chart':url+'?id=rd_l_line',
    'control_data_grid':url+'?id=rd_l_grid',
    'control_data_list':url+'?id=rd_l_list',
    'control_crosstab':url+'?id=rd_l_crosstab',
    'control_gauge_chart':url+'?id=rd_l_gauge',
    'control_value':url+'?id=rd_l_value',
    'control_filter_input':url+'?id=rd_l_filter_input',
    'control_filter_selector':url+'?id=rd_l_filter_selector',
    'control_clear_filter_button':url+'?id=rd_l_clear_filter',
    'command_exit':url+'?id=fd_b_exit',
    'command_simple_branch':url+'?id=fd_b_simple_branch',
    'command_multiple_branch':url+'?id=fd_b_multiple_branch',
    'command_run':url+'?id=fd_b_run_behavior',
    'command_comment':url+'?id=fd_b_comment',
    'command_submit_data':url+'?id=fd_b_submit',
    'command_close':url+'?id=fd_b_close',
    'command_show_message':url+'?id=fd_b_show_message',
    'command_print':url+'?id=fd_b_print',
    'command_show_page':url+'?id=fd_b_show_page',
    'command_show_url':url+'?id=fd_b_show_url',
    'command_cancel_submission':url+'?id=fd_b_cancel',
    'command_set_field_value':url+'?id=fd_b_set_field',
    'command_copy_field_values':url+'?id=fd_b_copy',
    'command_set_properties':url+'?id=fd_b_set_property',
    'command_show':url+'?id=fd_b_show',
    'command_set_state':url+'?id=fd_b_set_state',
    'command_check_obligatory':url+'?id=fd_b_check_mandatory',
    'command_start':url+'?id=fd_b_start',
    'command_start_stop': url+'?id=fd_b_startstop',
    'command_set_table_rows':url+'?id=fd_b_set_table',
    'command_notify':url+'?id=fd_b_notify',
    'command_set_next_stage':url+'?id=fd_b_set_next_stage',
    'command_cancel_notification':url+'?id=fd_b_cancel_notify',
    'command_connect':url+'?id=fd_b_connect',
    'command_connect_search':url+'?id=fd_b_connect_search',
    'command_transaction':url+'?id=fd_b_transaction',
    'command_show_form':url+'?id=fd_b_show_form',
    'command_show_report':url+'?id=fd_b_show_report',
    'command_get_field_from_other':url+'?id=fd_b_get_field_from',
    'command_set_field_in_other':url+'?id=fd_b_set_field_in',
    'command_call_javascript':url+'?id=fd_b_call_javascript',
    'control_report_refresh':url+'?id=rd_b_refresh',
    'control_set_filter':url+'?id=rd_b_set_filter',
    'control_clear_filter':url+'?id=rd_b_clear_filter',
    'command_set_selection_items':url+'?id=fd_b_set_selection',
    'connection_arrow_behavior':url+'?id=fd_b_connector',
    'connection_arrow_workflow': url+'?id=fd_w_path',
    'workflow_stage':url+'?id=fd_w_stage',
    'workflow_comment':url+'?id=fd_w_comment',
    'form_group':url+'?id=fd_l_multiple',
    'report_group': url+'?id=rd_l_multiple',
    'workflow_group': url+'?id=fd_w_multiple',
    'behavior_form_group':url+'?id=fd_b_multiple',
    'behavior_report_group': url+'?id=rd_b_multiple',
    'mobile_designer_editor': url + '?id=m_fd_prop',
    'control_section': url + '?id=m_fd_sectprop',
    'M': url + '?id=m_fd_formprop'

};


class DocumentationService {

     getPFDocumentationLinkRoot() {
         return PFDocumentationLinkRoot;
    }
}
const documentationService = new DocumentationService();
export default documentationService;